<template>
    <div
        class="flex flex-col items-center justify-center gap-2 text-slate-500 dark:text-slate-400"
    >
        <div
            v-if="loading"
            class="w-8 h-8 rounded-full border-2 border-orange-200 border-t-10x-orange animate-spin"
        />
        <template v-else>
            <Icon icon="chart" :width="20" :height="20" />
            <span class="text-sm text-slate-500 dark:text-slate-400">
                No data for selected period
            </span>
        </template>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

defineProps({
    loading: { type: Boolean, default: false },
});
</script>
